module.exports = "https://cdn.hellotech.com/client-assets/tech-services_1f0d253c77cfea5136840ab1e3e666c5.jpg";